import React, { Component } from "react";
import { Calendar, momentLocalizer  } from "react-big-calendar";
import moment from "moment";
import Serverurl from './Apiurl';
import axios from 'axios';
import SchedulePopUp from './SchedulePopUp';
import "react-big-calendar/lib/css/react-big-calendar.css";
import dayjs from 'dayjs';

moment.locale("en-GB");
const localizer = momentLocalizer(moment);
export default class ReactBigCalendar extends Component 
{
constructor(props) 
	  {
			super();
			
			this.state = {eventsData:[],scid:0,celldate:'',edate:''}
			  this.updateDonenewParent = this.updateDonenewParent;
	  }
	  		componentWillMount() { 
		
localStorage.setItem("pageactive",7)
}
 handleSelect=(date)=>{
	console.log(date);
 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date1=date.getFullYear()+"-"+month+"-"+date1
	 this.setState({ scid: 0 ,celldate:date1,edate:date},()=>{this.refs.SchedulePopUp.handleClickOpen()}); 

	
 }
 
  handleScheduleclass=(start,scid)=>{
	alert(this.state.scid);
	   this.setState({ scid: scid },()=>{this.refs.SchedulePopUp.handleClickOpen()});  
	   
  }
  updateDonenewParent = (text) => { this.ScheduleAPIcall();  }
 componentDidMount() {
	 	document.title = "AthaYog Living - Schedule";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	 this.ScheduleAPIcall();
	 
 }
ScheduleAPIcall()
{
	
axios.get(Serverurl+'ajaxschedule.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({eventsData:resp.data});
			}
	   });
}

customDayPropGetter = (date) => {

  let data = this.state.eventsData;
  
   var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date=date1+"/"+month+"/"+date.getFullYear()
   var obj = data.find((item, index) => {
	  
	   
	   
	   
	     if ((item.scdate === date && item.stname !== "")  )
		 {
			 
			   return data[index]
		 }

		 
   });
  
    if(obj !== undefined && obj.scdate === date &&  obj.stname !== "")
	{
	 
        return { style: { backgroundColor: "#2588f5", Color:'#fff' } }
	}
    
        else {return { style: { backgroundColor: "#fff", Color:'#fff' } }}
   
	
}

 eventStyleGetter=(event,start, end,isSelected)=>{

    console.log(event);
    var backgroundColor = '#2588f5' ;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: '#fff',
        border: '0px',
        display: 'block',
		textalign:'Center',
    };
    return {
        style: style
    };
}
render() {
  return (
  <div className="contentmain"> 
    <div className="pagebox-col"> 
	<div className="boxheading">
	  <div className="contntpad">
	  <h2>Schedule </h2>
	  </div> </div>
	
	<div className="contntpad">
	<SchedulePopUp ref="SchedulePopUp" id={this.state.scid} celldate={this.state.celldate} edate={this.state.edate} updateDonenew={this.updateDonenewParent}/>
	<Calendar       
        selectable
       localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
		dayPropGetter={this.customDayPropGetter }
        events={this.state.eventsData}
        style={{ height: "140vh" }}
        onSelectEvent={(event) => this.handleScheduleclass(event.start,event.id)}
		 eventPropGetter={(this.eventStyleGetter)}
        onSelectSlot={(event)=>this.handleSelect(event.start)}
      /> </div>
    </div>
	</div>
  );
}
}

